// extracted by mini-css-extract-plugin
module.exports = {"container":"complicated_container__3tsDg","button":"complicated_button__2sNAQ"};